import 'regenerator-runtime/runtime';
import { SagaIterator } from 'redux-saga';
import { put, select, takeEvery } from 'redux-saga/effects';
import { AnyAction } from 'redux';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { TgvActions } from '../tgvActions';
import { findStoreState } from './sharedDispatcher';

interface ToolbarState {
  versicherungsnehmer?: { juristisch?: boolean } | null;
}

const isJuristischePerson = (): boolean => {
  const toolbar = findStoreState(App.SHOP_TOOLBAR) as ToolbarState | undefined;
  const dashboard = findStoreState(App.SHOP_DASHBOARD);
  return toolbar?.versicherungsnehmer?.juristisch === true || dashboard?.['juristisch'] === true;
};

export function* watchJuristisch(): SagaIterator {
  yield takeEvery(
    [
      GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL,
      GlobalActions.SAVED_STATES_LOADED,
      GlobalActions.TIERGRUPPE_EINGABE_TARGET_SET,
    ],
    safeSaga(juristischSaga, App.TGV),
  );
}

export function* juristischSaga(action: AnyAction): SagaIterator {
  const { transientState }: IAppState = yield select();
  const juristisch = isJuristischePerson();
  const reportsAgain = action.type === GlobalActions.SAVED_STATES_LOADED && juristisch;
  if (juristisch !== transientState.juristisch || reportsAgain) {
    yield put(new TgvActions().juristischReceived(juristisch));
  }
}
